module.exports = __webpack_public_path__ + "s_play.f23564ad.png";